import { Component } from '@angular/core';

@Component({
    selector: 'document-card-skeleton',
    templateUrl: 'document-card-skeleton.component.html',
    styleUrl: 'document-card-skeleton.component.scss',
    standalone: true,
})
export class DocumentCardSkeletonComponent {}
